import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  ion-content {
    position: relative;

    .logo-class {
      margin: 16px 0 0;
    }
  }

  #root .ion-page & {
    ion-footer {
      padding: 16px 16px 32px;

      .page-footer-button {
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        border-radius: 12px;
      }
    }
  }
`;

export const PageTitleStyles = styled(UiTypography)`
  .ion-page & {
    margin: 20px 0 12px;
    font-weight: 600;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  font-size: 0;
  line-height: 0;
  position: relative;
  background: url(../assets/bg-circles.png);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 450px 450px;
  text-align: center;

  @media (min-width: 440px) {
    background-size: 500px 500px;
  }

  .main-image {
    z-index: 1;
    width: 100%;
    aspect-ratio: 0.6775;
    max-width: 280px;

    @media (min-width: 440px) {
      max-width: 315px;
    }
  }

  .phrase-image {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 240px;
    aspect-ratio: 1.446;
  }
`;
